import { getAgeMax } from './getAgeMax';
import { getAgeMin } from './getAgeMin';
import { getFreeCancelation } from './getFreeCancelation';
import { getInstantConfirmation } from './getInstantConfirmation';
import { getNumVisitors } from './getNumVisitors';
import { getPriceMax } from './getPriceMax';
import { getPriceMin } from './getPriceMin';
import { getSelectedMonths } from './getSelectedMonths';

export const fromParams = {
  getAgeMax,
  getAgeMin,
  getFreeCancelation,
  getInstantConfirmation,
  getNumVisitors,
  getPriceMax,
  getPriceMin,
  getSelectedMonths,
};
